export const CREATE_CONTACT_FOLLOW_UP_NOTE = `
  mutation createContactFollowUpNote($input: CreateFollowUpNoteInput!, $tenant_id: Int!) {
    createContactFollowUpNote(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ContactLog {
        id
        contact_id
        log_action_id
        log_action {
          id
          name
          translation_key
        }
        description
        role_type
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CREATE_FOLLOW_UP_NOTE = `
  mutation createFollowUpNote($input: CreateFollowUpNoteInput!, $tenant_id: Int!) {
    createFollowUpNote(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ContactLog {
        id
        contact_id
        log_action_id
        log_action {
          id
          name
          translation_key
        }
        description
        role_type
        old_status_id
        new_status_id
        new_status {
          id
          name
        }
        user {
          email
          contact {
            firstname
            lastname
          }
        }
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
